import React from 'react'
import Image from 'next/image'
import dynamic from 'next/dynamic'

const Hero = dynamic(() => import('../components/Hero'))
const Footer = dynamic(() => import('../components/Footer'))
const Newsletter = dynamic(() => import('../components/Newsletter/Newsletter'))

const service = [
  {
    id: 1,
    title: 'Inter-State Transportation',
    alt: 'ANET Individual travels',
    src: '/images/ANET_INDIVIDUAL.svg',
    description:
      'ANET provides travellers with affordable and convenient vehicles to travel across states, either alone or in groups, at affordable prices without a drop in the quality of service.'
  },
  {
    id: 2,
    title: 'Charter Services',
    alt: 'ANET Bus hire services',
    src: '/images/ANET_BUS_HIRE.svg',
    description:
      'Travellers can choose to hire from our fleet of buses, which an individual or group can utilize for a more spacious and comfortable experience.'
  },
  {
    id: 3,
    title: 'special needs',
    alt: 'ANET special needs services',
    src: '/images/ANET_SPECIAL_NEEDS.svg',
    description:
      'Clients with unique demands can choose our special needs option, which allows services tailored to their specifications.'
  }
]

const Services = () => {
  return (
    <>
      <Hero>
        <section className='lg:px-20 2xl:px-40 md:px-20 px-6 py-20 md:py-40 flex w-full flex-col'>
          <section className='md:my-16 flex mb-12 md:mb-5'>
            <section className='md:w-9/12'>
              <h1 className='text-white md:text-4xl lg:text-5xl text-2xl uppercase mb-8'>
                who we are
              </h1>
              <p className='text-white text-base lg:text-2xl md:text-lg my-4'>
                We are a team of entrepreneurs, transport and logistics experts
                inspiring a new wave of convenience and comfort in commuting
                people and goods. Our services are anchored on cutting-edge
                technology, exceptional staff members, and simplified processes
                to ensure a smooth customer journey. The utilisation of our
                private car services to pick up and drop off passengers provide
                an extra layer of comfort, luxury, and ultimately the safety of
                the passengers. Our haulage brings fast and efficient cargo
                transportation while ensuring the safe delivery of all items in
                our custody.
              </p>
            </section>
          </section>
          <section className='md:my-16 justify-end flex md:text-right'>
            <section className='md:w-9/12'>
              <h1 className='text-white md:text-4xl lg:text-5xl text-2xl uppercase'>
                WHAT WE OFFER
              </h1>
              <p className='text-white text-base lg:text-2xl md:text-lg my-4'>
                Our services are anchored on cutting-edge technology and
                exceptional staff members, services and simplified processes to
                , each peculiar to the customer’ request. The utilisation of our
                private car services sees our clients either as an individual or
                group enjoy comfort and luxury together with safety being the
                highest on our priority list. ANET’s haulage brings fast and
                efficient cargo transportation while ensuring the safety of such
                cargo, reducing the risk of damage.
              </p>
            </section>
          </section>
        </section>
      </Hero>
      <section className='flex flex-col items-center py-12 lg:px-20 2xl:px-40 md:px-20 px-6 my-8 md:my-16'>
        <h2 className='text-priColor text-2xl md:text-3xl font-bold'>
         OUR SERVICES
        </h2>
        <section className='flex flex-wrap justify-between my-12'>
          {service.map((service) => (
            <section
              className='flex flex-col items-center servicesCard py-3 text-center w-full md:w-31 p-6 mb-10 md:mb-0'
              key={service.id}
            >
              <section className='relative h-20 md:h-28 w-24 md:w-28 lg::w-40 my-5'>
                <Image
                  src={service.src}
                  alt={service.alt}
                  layout='fill'
                  objectFit='contain'
                />
              </section>
              <h3 className='text-2xl text-gray600 font-bold my-4 capitalize'>
                {service.title}
              </h3>
              <p className='text-base text-cardGrey mb-6 md:text-lg'>
                {service.description}
              </p>
            </section>
          ))}
        </section>
      </section>
      <Newsletter />
      <Footer />
    </>
  )
}

export default Services